import request from '@/utils/request'

export function getReferralConfig() {
  return request({
    url: '/biz/giftcard/referral-config/get',
    method: 'get'
  })
}

export function saveReferralConfig(data) {
  return request({
    url: '/biz/giftcard/referral-config/save',
    method: 'post',
    data
  })
}
